import { useState } from "react";
import { useHistory } from "react-router-dom";
import Avatar from "@material-ui/core/Avatar";
import MenuItem from "@material-ui/core/MenuItem";
import {
  Badge,
  Box,
  Divider,
  Popover,
  Typography,
  useMediaQuery,
  withStyles,
} from "@material-ui/core";
import { AccountCircle } from "@material-ui/icons";
import { FiCircle, FiLogOut } from "react-icons/fi";
import { hideMaskCPF } from "../../../../../../utils/cpfMask";
import { nameSplitTwo, nameSplitOne } from "../../../../../../utils/nameFormat";
import { useUserAvatarStyles } from "./styles";
import { logout } from "../../../../../../services/auth";
import theme from "../../../../../../providers/theme-service";
import { useAuth } from "../../../../../../contexts/auth";

const StyledBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: "#44b700", // verde
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    width: 10,
    height: 10,
    borderRadius: "50%",
    bottom: 0,
    right: 0,
  },
}))(Badge);

export default function UserAvatar() {
  const history = useHistory();
  const { authUser: user, changeCurrentTicketOffice, adminUser } = useAuth();
  const { classes } = useUserAvatarStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const matchesMobile = useMediaQuery("(min-width:576px)");

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const logoutUser = () => {
    logout();
    handleClose();
  };

  function handleSwitchProfile() {
    changeCurrentTicketOffice(null);
    history.push("/");
  }

  return (
    <>
      <StyledBadge
        overlap="circle"
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        variant="dot"
      >
        <Avatar
          alt="Remy Sharp"
          onClick={handleClick}
          style={{
            cursor: "pointer",
            width: 32,
            height: 32,
            backgroundColor: theme.palette.primary.main,
          }}
        >
          <AccountCircle fontSize="small" />
        </Avatar>
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <Box>
            {user && (
              <MenuItem
                style={{
                  backgroundColor: "#F3F6FA",
                  // minHeight: 73,
                }}
              >
                <Avatar className={classes.avatar} />
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="flex-start"
                >
                  <Typography className={classes.textName} color="primary">
                    {matchesMobile
                      ? nameSplitTwo(user?.nome?.toLowerCase())
                      : nameSplitOne(user?.nome?.toLowerCase())}
                  </Typography>
                  <Typography color="primary" className={classes.textCpf}>
                    {hideMaskCPF(user.cpf || "")}
                  </Typography>
                </Box>
              </MenuItem>
            )}
            <Divider />
            <MenuItem className={classes.menuItem} onClick={handleSwitchProfile}>
              <FiCircle />
              <Typography className={classes.textMenuItem}>Trocar perfil</Typography>
            </MenuItem>
            <MenuItem className={classes.menuItem} onClick={logoutUser}>
              <FiLogOut />
              <Typography className={classes.textMenuItem}>Sair</Typography>
            </MenuItem>
            <Divider />
          </Box>
        </Popover>
      </StyledBadge>
    </>
  );
}
